import { jsx as _jsx } from "react/jsx-runtime";
import Stick from '../../../es';
import Regression from './Regression';
export default function ButtonOverlay() {
    return (_jsx(Regression, { allBrowsers: true, fixed: true, title: "Button overlay", description: "Stick created an element that prevented clicks to wrapped elements", children: _jsx(Stick, { node: "This is the stick text", children: _jsx("button", { children: "You should be able to click me" }) }) }));
}
